import { __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { SpinnerOutlineIcon } from '@compono/ui-icons';
import 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { hiddenVisuallyCSS } from '../HiddenVisually/index.js';
import { Box } from '../Box/index.js';
import { Text } from '../Text/Text.js';

var Loader = function (_a) {
    var _b = _a.align, align = _b === void 0 ? "left" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.label, label = _d === void 0 ? "Loading..." : _d, _e = _a.hideLabel, hideLabel = _e === void 0 ? false : _e;
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ variant: "".concat(size, "-").concat(align), size: size }, { themeKey: "loader" });
    var loaderIconForwardProps = handleStyleProps({ align: align }, { themeKey: "loaderIcon" });
    var labelCss = hideLabel && hiddenVisuallyCSS;
    return (jsxs(Box, __assign({ role: "alert", "aria-busy": true, "aria-live": "polite" }, forwardProps, { children: [jsx(SpinnerOutlineIcon, __assign({ "aria-hidden": true }, loaderIconForwardProps)), jsx(Box, __assign({ sx: __assign({}, labelCss) }, { children: jsx(Text, __assign({ size: size }, { children: label })) }))] })));
};
Loader.displayName = "Loader";

export { Loader };
//# sourceMappingURL=Loader.js.map
